import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserBookmarks.translations.json';
import React from 'react';
import { DashboardPanel } from '../DashboardPanel';
import * as Icon from 'react-feather';
import { useListUserBookmarkQuery } from '../settings/userBookmarks/query/useGetUserBookmarkQuery';
import { keepPreviousData } from '@tanstack/react-query';
import { InfoIconUrl, TextEllipsis } from '../../common/components';
import { Flex } from 'antd';
import { TextLink } from '../../common/components/typography';

const { addTranslations, t } = i18nNsFactory('user-bookmarks');
addTranslations(translations);

export const UserBookmarks = () => {
  const { data: bookmarks = [], isLoading } = useListUserBookmarkQuery({
    placeholderData: keepPreviousData,
  });
  return (
    <DashboardPanel
      title={t('title')}
      infoIconUrl={InfoIconUrl.USER_BOOKMARKS}
      icon={<Icon.Bookmark size={18} />}
      isLoading={isLoading}
      style={{ flex: 0.5, maxWidth: 600, minWidth: 0 }}
    >
      <Flex vertical gap="small" flex={0}>
        {bookmarks.map((bookmark) => (
          <TextEllipsis key={bookmark.id}>
            <TextLink
              id={`bookmark-${bookmark.id}`}
              href={bookmark.url}
              target="_blank"
            >
              {bookmark.name}
            </TextLink>
          </TextEllipsis>
        ))}
      </Flex>
    </DashboardPanel>
  );
};
